import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class CoffeeMakerIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        color: '#8e8e8e',
        size: 50
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.25).toString()} width={(size / 1.25).toString()} viewBox="0 0 300 286.62">
                <g fill={color}>
                    <path d="M12.13 274.49a39.85 39.85 0 0 0 29.26 12.13h206.88a41.39 41.39 0 0 0 41.38-41.38H0a39.84 39.84 0 0 0 12.13 29.26zm0 0M77.58 224.54h113.8a36.43 36.43 0 0 0 36.21-36.23v-5.17h10.34a59.85 59.85 0 0 0 43.89-18.18A59.84 59.84 0 0 0 300 121.11a59.84 59.84 0 0 0-18.18-43.9 59.84 59.84 0 0 0-43.89-18.18H51.73a10.49 10.49 0 0 0-10.35 10.35v118.93A34.84 34.84 0 0 0 52 213.88a34.84 34.84 0 0 0 25.54 10.67zm150-134.47h10.35a30.89 30.89 0 0 1 31 31 30.89 30.89 0 0 1-31 31h-10.34zm0 0M130.06 1.73a4.62 4.62 0 0 0-6.25.28 4.7 4.7 0 0 0-.6 6.4c.31.42.66.82 1 1.22.21.24.42.48.62.73 3.08 3.9 2.92 6.94-.55 10.49a41.31 41.31 0 0 0-3.28 3.67 15.55 15.55 0 0 0-3.59 9.67c0 4.71 3.07 11 6.71 13.84a5 5 0 0 0 3 1 4.79 4.79 0 0 0 3.33-1.35 4.71 4.71 0 0 0 .61-6.31 10.91 10.91 0 0 0-.86-1l-.33-.37c-3.72-4.38-3.59-7.41.51-11.56a29.55 29.55 0 0 0 4.62-5.85c4.25-7.41.74-16.1-4.94-20.86zM163 28.24c.31-.31.61-.62.9-.93l.82-.87a24.08 24.08 0 0 0 2.28-2.62c6-8.35 2.51-17.41-3.61-22.68a4.74 4.74 0 0 0-6.47.3 4.73 4.73 0 0 0-.35 6.49c.27.34.55.67.84 1s.4.46.6.7c3.1 3.87 3 6.91-.46 10.51l-.32.33a43.5 43.5 0 0 0-2.94 3.3 16.16 16.16 0 0 0-3.67 10v.08c.1 4.25 1.89 8.18 5.64 12.39a5.66 5.66 0 0 0 3.88 2.14h.23a4.3 4.3 0 0 0 2.91-1.16c2.15-1.94 2.22-4.79.12-7.35a22.76 22.76 0 0 1-2.14-2.87c-1.61-2.77-1.46-4.94.54-7.49a15.48 15.48 0 0 1 1.2-1.27zM98.64 27.26l.81-.8a16.58 16.58 0 0 0 5.25-12.15c-.11-4.67-2.38-9.25-6.38-12.9a4.79 4.79 0 0 0-6.74.05 4.72 4.72 0 0 0-.3 6.62c.28.35.56.69.85 1a17.76 17.76 0 0 1 1.12 1.39c2.31 3.34 2.19 5.84-.43 8.94-.44.52-.92 1-1.39 1.51s-1.07 1.11-1.56 1.69a17.2 17.2 0 0 0-4.59 11.26c.06 5.57 3.34 9.85 5.8 12.58A5.36 5.36 0 0 0 95 48.41a4.32 4.32 0 0 0 2.89-1.1c2.17-1.92 2.31-4.73.34-7.15l-.29-.35a23 23 0 0 1-2.16-2.94 5.77 5.77 0 0 1 .6-7.22 30.87 30.87 0 0 1 2.26-2.39z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(CoffeeMakerIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/CoffeeMakerIcon.js